export default "__VITE_ASSET__DwumSE9k__"